/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NzbnCompanyDetailsBaseResponse as ModelsCustomerNzbnCompanyDetailsBaseResponse } from '../../models/Models/Customer/nzbn-company-details-base-response';

export interface V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Params {
  nzbn: string;
  applicationId: string;
}

export function v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain(http: HttpClient, rootUrl: string, params: V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain.PATH, 'get');
  if (params) {
    rb.path('nzbn', params.nzbn, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>;
    })
  );
}

v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain.PATH = '/v4/public/application/{applicationId}/getCompanyAutocomplete/{nzbn}';
